import React, { useState } from "react";
import imgProductLakay from '../Layout/imgs/md3.jpg'

import { isAuthenticated } from "../auth";
import {taxProductAreaByState} from "../auth/apiProduct";
import {shippingData, usaState} from "../pageInside/shippingInfo"
import CatSearch from '../pages/categories/catSearch'
import { FaTags, FaMoneyBillWave, FaPercentage, FaTruck, FaChartLine, FaReceipt, FaDollarSign, FaMapMarkerAlt, FaBullseye, FaCoins, FaArrowDown, FaArrowUp, FaEquals, FaShippingFast, FaStore, FaQuestionCircle } from "react-icons/fa";
import "./salesSimulation.css"

import PricingModeSelector from "./PricingModeSelector";
import useSalesSimulation from "./useSalesSimulation";
import SimulationTaxInput from "./SimulationTaxInput";
import { elakayAutoText } from "./dataElakay";
import { findUsaZipArea } from "./usaZipIndex";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["salesSimulation"]?.[key] || fallback;

const SalesSimulation = (props)=>{
    const {
        search,
        setSearch,
        getCategoriesByName,
        setSearchInput,
        searchInput,
        categories,
        loadCategory,
        laguangeElakay,
        infoSource,
        clotureFeet = 0.50,
        token
    }= props
    __setElakayInfoSource(infoSource);

    const product = {
        price : 0,
        constPrice :0,
        salePrice: 0,
        count: 1
    }

    const gestionVente = {
        purchasePrice: 0,
        ProfitPrice : 0
    }
    const simulationPrice = {
        ItemsOrder: 0,
        prodDiscount : 0,
        prodPrice: 0,
        prodFrService: 0, 
        prodFrVente: 0,
        prodFrRef: 0,
        TaxOrder: 0,
        getTotal: 0,
        prodFrTransaction: 0,
        totalFrais: 0,
        inComeSeller: 0,
        elakayFrais: 0,
        statut: {profit: 0, loss : 0, statut: 'break-even point'}
    }
    const [shippingboo, setShippingboo ]= useState(false)
    const [getLinkShoose, setLinkShoose]= useState({contries:'', compagnies: '', services: '' })   
    const [getshipping, setShipping ]= useState([])
    const [deliveryTime, setDeliveryTime] = useState([])
    const [getShipPriceSelect, setShipPriceSelect] = useState({price: 0,  Select: ''})
    const [cellSeleted, setCelleseleted] = useState([])
    const [getProduct, setProduct]= useState(product)
    const [getTaxArea, setTaxArea]= useState({})
    const [getPurchaseProduct, setPurchaseProduct] = useState(gestionVente)
    const [getBySellProfit, setBySellProfit]= useState(true)
    
    const simulation = useSalesSimulation({
        pricingMode: getBySellProfit ? "selling_price" : "desired_profit",
        sellingPrice: Number(getProduct.price) || 0,
        desiredProfit: Number(getPurchaseProduct.ProfitPrice) || 0,
        purchasePrice: Number(getPurchaseProduct.purchasePrice) || 0,
        discountPercent: Number(getProduct.salePrice) || 0,
        sellerShippingCost: shippingboo ? Number(getShipPriceSelect.price) || 0 : 0,
        taxRate: Number(getTaxArea?.EstimatedCombinedRate) || 0,
        categoryId: categories?._id || categories?.publicId,
    }, token || isAuthenticated()?.token);
    const getSimulationPrice = simulation.result?.receipt || simulationPrice;
    const taxRequest = React.useRef(0);
    const newCartProd = async (postalCode) => {
        const request = ++taxRequest.current;
        setTaxArea({});
        const area = await findUsaZipArea(postalCode);
        if (!area || request !== taxRequest.current) return;
        try {
            const data = await taxProductAreaByState("US", area.zip_code, area.state);
            if (request === taxRequest.current) setTaxArea(data?.zoneTax || {});
        } catch (error) {
            if (request === taxRequest.current) setTaxArea({});
        }
    };

    const convertToNewArray = (obj) => {
        const result = [];
        for (const serviceName in obj.services) {
          const service = obj.services[serviceName];
          result.push({
            name: serviceName,
            ecommerce: {
              standard: service.ecommerce.standard,
              professional: service.ecommerce.professional_account
            },
            wholesale: {
              standard: service.wholesale.standard,
              professional: service.wholesale.professional_account
            },
            retail: {
              standard: service.retail.standard,
              professional: service.retail.professional_account
            },
            deliveryTime: service.delivery_time
          });
        }
        return { services: result };
      }

    const {
        price,
        salePrice,
        count
        } = getProduct

        let contryShip = ["USA",  "Canada"]
        let shippinselected = ['Minimum', 'Moyenne', 'Maximum']

        const keyValue = (get, set )=>{ 
            // let k = Object.keys(get)
            // let v = Object.values(get)
            if(set === 'keys'){
                return  Object.keys(get)
            }else if(set === 'values'){
                return Object.values(get)
            }else{
            return get
            }
        }
        const convertToArray = (priceRange)=>{
          // Enlever les symboles $ et les espaces, et separer par le tiret
  const parts = priceRange.replace(/\$/g, '').split('-')?.map(part => part.trim());

  // Convertir les parties en nombres flottants
  const prices = parts?.map(part => parseFloat(part));

  return prices;
        }
        
        const handleChange=(name)=>event=>{
            let value = event.target.value
            if(name === 'price'){
                setLinkShoose({contries:'', compagnies: '', services: '' }) 
                setShipPriceSelect({price: 0,  Select: ''})
                setShipping([])
                setDeliveryTime('')
                setCelleseleted([])
                setShippingboo(false)
                setProduct({ ...getProduct, [name]: value, constPrice: value});   
            }else{
            setProduct({ ...getProduct, [name]: value});
            }
          
        }

        const handlePP=(name)=>event=>{
            setShippingboo(false)
            setShipping([])
            setDeliveryTime('')
            setCelleseleted([])
            setLinkShoose({contries:'', compagnies: '', services: '' }) 
            setShipPriceSelect({price: 0,  Select: ''})
        const value = event.target.value;
        if(name ==='purchasePrice'){
            setBySellProfit(true)
            setProduct({ price : 0, salePrice: 0, constPrice: 0, count: 1})
            setPurchaseProduct({  purchasePrice: value, ProfitPrice : 0})
        }
        if(name ==='ProfitPrice'){
            setPurchaseProduct({ ...getPurchaseProduct, [name]: value });
        }
        }

        const handleChangeAdress=(name)=> event=>{
            const value = event.target.value;
            newCartProd(value)
          
        }
let contries = shippingData[1]
// let compagnie = shippingData[1][contrie[0]]
let contrie = keyValue(shippingData[1], 'keys')
let usps = keyValue(shippingData[1][contrie[0]], 'keys')
let uspsService = keyValue(shippingData[1][contrie[0]][usps[0]]['services'], 'keys')
let services0 = keyValue(shippingData[1][contrie[0]][usps[0]]['services'][uspsService[3]], 'key')

const formPurchase = ()=>{
   return <form className="w-75 sim-form">
             <div className="form-group">
                <label className="text-muted">
                    <FaDollarSign className="sim-label-icon" />
                    {/* Add your purchase price */}
                    {infoSource.language(infoSource, "sellPage", "AddPurchPrix")}
                    </label>
                <div className="sim-input-group">
                    <span className="sim-input-icon"><FaDollarSign /></span>
                    <input
                    onChange={handlePP('purchasePrice')}
                    aria-label={elakayAutoText("h_ps_purchase_price", "Purchase Price")}
                    type="number" min="0" step="0.01"
                    className="form-control rounded-5 sim-input"
                    value={getPurchaseProduct.purchasePrice}
                    placeholder={getPurchaseProduct.purchasePrice}
                    />
                </div>
                    <span className="font-weight-light text-info mx-4">
                    {/* The purchase price is the total amount paid to acquire a product for resale, including the cost of the product, shipping, taxes, and any other associated expenses. In Elakay, this includes all costs incurred to get the product ready for sale. */}
                    {infoSource.language(infoSource, "text", "textSellSimul1")}
                    </span>
            </div>
    </form>
}

const addfieldForm =()=>{
   return <form className="my-3 sim-form">
         {getBySellProfit?
          <div className="form-group">
                <label className="text-muted"><FaBullseye className="sim-label-icon" />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).salesSimulation.t001}</label>
                <div className="sim-input-group">
                    <span className="sim-input-icon"><FaDollarSign /></span>
                    <input
                    onChange={handleChange('price')}
                    aria-label={elakayAutoText("h_ps_target_price", "Target Selling Price")}
                    type="number" min="0" step="0.01"
                    className="form-control sim-input"
                    value={price}
                    placeholder={price}/>
                </div>
                <span className="font-weight-light text-danger mx-4">
                {/* Selling price you want to achieve */}
                {infoSource.language(infoSource, "sellPage", "SellWaAch")}
                </span>
            </div>
            :   <div className="form-group">
            <label className="text-muted"><FaCoins className="sim-label-icon" />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).salesSimulation.t002}</label>
            <div className="sim-input-group">
                <span className="sim-input-icon"><FaDollarSign /></span>
                <input
                onChange={handlePP('ProfitPrice')}
                aria-label={elakayAutoText("h_ps_desired_profit", "Desired Profit")}
                type="number" min="0" step="0.01"
                className="form-control sim-input"
                value={getPurchaseProduct.ProfitPrice}
                placeholder={getPurchaseProduct.ProfitPrice}
                />
            </div>
            <span className="font-weight-light text-danger mx-4">
            {/* Profit price you want to Desired  */}
            {infoSource.language(infoSource, "sellPage", "ProPriWaDes")}
            </span>
        </div>
            }
            <div className="form-group">
                <label className="text-muted">
                    <FaPercentage className="sim-label-icon" />
                    {/* discount */}
                    {infoSource.language(infoSource, "sellPage", "discount")}
                    </label>
                <div className="sim-input-group sim-input-group--suffix">
                    <input
                    onChange={handleChange('salePrice')}
                    aria-label={infoSource.language(infoSource, "sellPage", "discount")}
                    type="number" min="0" max="99.99" step="0.01"
                    className="form-control sim-input"
                    value={salePrice}
                    placeholder={salePrice}
                    />
                    <span className="sim-input-icon sim-input-icon--suffix"><FaPercentage /></span>
                </div>
            </div>

    </form>
}


const salesFromAdress = () =>{
  return <> <form className="my-3 sim-form">

       <div className="form-group">
            <label className="text-muted">
                <FaStore className="sim-label-icon" />
                {/* your shop */}
                {infoSource.language(infoSource, "sellPage", "yourShop")}
                 {infoSource.laguangeElakay('label', infoSource.languageAPI).zipCode}</label>
                  <div className="sim-input-group">
                     <span className="sim-input-icon"><FaMapMarkerAlt /></span>
                     <input id="postal-code" onChange={handleChangeAdress('postalCode')} type="text" placeholder={infoSource.laguangeElakay('label', infoSource.languageAPI).zipCode}
                                                        className="form-control sim-input"/>
                    </div>
                    <p className="help-block"></p>
        </div>
        <SimulationTaxInput infoSource={infoSource} value={getTaxArea?.EstimatedCombinedRate ?? 0}
            onChange={rate => {
                taxRequest.current += 1;
                setTaxArea({ EstimatedCombinedRate: rate });
            }} />
    </form>
    </>
}




const getShipping =(a, b, c, d, e)=>{
    let newArraySHip = convertToArray(a)
    setCelleseleted([c, d, e])
    setDeliveryTime([b, a])
    handleMinMoyMax(getShipPriceSelect.Select, newArraySHip)
    setShipping(newArraySHip)
}


const headTitle = ['E-commerce (Standard)', 'E-commerce (Pro Account)',  'Vente en Gros (Standard)', ' Vente en Gros (Pro Account)', 'Vente au Detail (Standard)', 'Vente au Detail (Pro Account)']
const cellStyleSelect = (a, b)=>{
    return cellSeleted[1] == a && cellSeleted[2] == b ? {backgroundColor: '#C0C0C0'}: {}
}
let objKey = shippingboo && getLinkShoose.contries && getLinkShoose.compagnies && Object.keys(shippingData[1][getLinkShoose.contries][getLinkShoose.compagnies]['services'])
let objvalue = shippingboo && getLinkShoose.contries && getLinkShoose.compagnies && Object.values(shippingData[1][getLinkShoose.contries][getLinkShoose.compagnies])
let newArray = objKey = shippingboo && getLinkShoose.contries && getLinkShoose.compagnies && convertToNewArray({services: objvalue && objvalue[0]})
const ShippingTable = () => {
    const data = newArray.services;

    return (
        <table className="saleSim">
          <thead>
            <tr>
              <th >
                {/* Service */}
                {infoSource.language(infoSource, "sellPage", "service")}
                </th>
              <th > 
                {/* E-commerce (Standard) */}
                {infoSource.language(infoSource, "sellPage", "EcomStandard")}
                </th>
              <th >
                {/* E-commerce (Pro Account) */}
                {infoSource.language(infoSource, "sellPage", "ecomProAccount")}
                </th>
              <th >
                {/* Vente en Gros (Standard) */}
                {infoSource.language(infoSource, "sellPage", "VentGroStand")}
                </th>
              <th >
                {/* Vente en Gros (Pro Account) */}
                {infoSource.language(infoSource, "sellPage", "VentGroPrAcco")}
                </th>
              <th >
                {/* Vente au Detail (Standard) */}
                {infoSource.language(infoSource, "sellPage", "VenDetaiStand")}
                </th>
              <th >
                {/* ente au Detail (Pro Account) */}
                {infoSource.language(infoSource, "sellPage", "entDetProAcc")}
                </th>
              <th >
                {/* Delai de Livraison */}
                {infoSource.language(infoSource, "sellPage", "delaiLivrai")}
                </th>
            </tr>
          </thead>
          <tbody>
            {data?.map((service, index) => (
              <tr key={index}>
                <td >{service.name}</td>
                <td style={cellStyleSelect(index, 0)} onClick={()=>getShipping(service.ecommerce.standard, service.deliveryTime, service.name, index, 0)}><span>{service.ecommerce.standard}</span></td>
                <td style={cellStyleSelect(index, 1)}  onClick={()=>getShipping(service.ecommerce.professional, service.deliveryTime, service.name, index, 1)}>{service.ecommerce.professional}</td>
                <td style={cellStyleSelect(index, 2)} onClick={()=>getShipping(service.wholesale.standard, service.deliveryTime, service.name, index, 2)}>{service.wholesale.standard}</td>
                <td style={cellStyleSelect(index, 3)} onClick={()=>getShipping(service.wholesale.professional, service.deliveryTime, service.name, index, 3)}>{service.wholesale.professional}</td>
                <td style={cellStyleSelect(index, 4)} onClick={()=>getShipping(service.retail.standard, service.deliveryTime, service.name, index,  4)}>{service.retail.standard}</td>
                <td style={cellStyleSelect(index, 5)} onClick={()=>getShipping(service.retail.professional, service.deliveryTime, service.name, index, 5)}>{service.retail.professional}</td>
                <td >{service.deliveryTime}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
  };
const addShippingBoo = () =>{
    setLinkShoose({contries:'', compagnies: '', services: '' }) 
    setShipPriceSelect({price: 0,  Select: ''})
    setProduct({ ...getProduct, price: getProduct.constPrice})
    setShipping([])
    setDeliveryTime('')
    setCelleseleted([])
    if(shippingboo){
 setShippingboo(false)
    }else{
        setShippingboo(true)
    }
}
let allPrice = ['Purchase price', 'Applicable taxes', 'Shipping costs', 'Discounts', 'Payment fees', 'Service fees', 'Selling price you want to achieve', 'Desired profit', 'Potential loss']
const infoDiscount = ()=>{
    return <div className="sim-intro">
        <img className="sim-intro__img" src={imgProductLakay} width="100" alt=""/>
        <div className="sim-intro__content">
            <p>
            {/* We are launching a simulation to help you determine the optimal price at which you can sell your products by considering various essential factors. This simulation will not only enable you to understand how to set your selling prices competitively but also to achieve the desired profit while remaining attractive compared to competitors in the market. By participating in this simulation, you will be able to accurately evaluate how much you can sell your products for, taking into account your purchase price, applicable taxes, shipping costs, discounts, payment fees, service fees, the selling price you want to achieve, the desired profit, and any potential loss. This approach aims to provide you with a comprehensive analysis to optimize your sales strategies and maximize your profits. */}
            {infoSource.language(infoSource, "text", "textSellSimul")}
            </p>
            <ul className="sim-checklist">
           { allPrice?.map((l, i)=><li key={i}>{l}</li>)}
            </ul>
        </div>
    </div>
}

const TableInfoShip =()=>{
return    <>
<p>
    {/* We would like to inform you that you have the option to add the shipping cost to the product price if necessary. Many sellers adopt this approach while maintaining their competitiveness in the market. This strategy can help manage shipping expenses effectively and ensure your pricing remains attractive to customers. */}
    {infoSource.language(infoSource, "text", "textSellSimul0")}
</p>

<form className="my-3 w-75 sim-form">
    <div className="form-group">
                <label className="text-muted">
                    <FaQuestionCircle className="sim-label-icon" />
                    {/* do you want to add the shipping cost to the product price? */}
                    {infoSource.language(infoSource, "sellPage", "WaaddshipCosProdPri")}
                    </label>
                <select value={shippingboo} className="mx-4 sim-select" onChange={()=> addShippingBoo()}>
                    <option value='' >{infoSource.laguangeElakay('label',  infoSource.languageAPI).pleaseSelect}</option>
                    <option value={false}>{infoSource.laguangeElakay('label',  infoSource.languageAPI).no} </option>
                    <option value={true}>{infoSource.laguangeElakay('label',  infoSource.languageAPI).yes}</option>
                </select> 
                {/* <span className="font-weight-light text-info"> {infoSource.laguangeElakay('label',  infoSource.languageAPI).onChargeShipping}</span> */}
                <p className="font-weight-light text-danger"> 
                    {/* Shipping will be your responsibility. We are preparing a shipping business plan for those who want it. We will inform you as soon as it is ready. */}
                    {infoSource.language(infoSource, "sellPage", "shipResponsb")}
                    </p>
    </div>
</form>
    {shippingboo && selectTypelist()}
    {shippingboo && getLinkShoose.contries && selectcompagnies()}
    {  shippingboo && getLinkShoose.contries && getLinkShoose.compagnies && <>
    
    <h4 className="m-1">{getLinkShoose.compagnies}</h4>
    <h6 className="text-primary">
        {/* Frais de Shipping Local in  */}
        {infoSource.language(infoSource, "sellPage", "FraiShipLoc")}
        {getLinkShoose.contries}</h6>
      <ShippingTable 
      country={getLinkShoose.contries} 
      company={getLinkShoose.compagnies} 
      />
      </>}

      {selectMinMoyMax()}
      </>
}
const allForm =()=>{
    return <div className="row"> 
        <div className=" col col-md-6">
        {addfieldForm()}
        </div>
        <div className=" col col-md-6">
        {salesFromAdress()}
        </div>
    </div>
}
const handleStylePara = (v, k, o)=>{
    if(o ==='a'){
    setLinkShoose({contries: v})
    }else if (o ==='b'){
        setLinkShoose({...getLinkShoose, compagnies: v})
    }else if (o ==='c'){
        setLinkShoose({...getLinkShoose, services: v})
    }
}

const handleMinMoyMax = (o, k)=>{ 
    if(o ==='Minimum'){
        let shi = k[0] 
        let nwePriceProd = Math.abs(getProduct.constPrice) + shi
        if (getBySellProfit) setProduct({...getProduct, price: nwePriceProd})
        setShipPriceSelect({price: shi,  Select: 'Minimum'})
      
  
    }else if (o ==='Moyenne'){
        let shi = (k[0] +  k[1])/2
        let nwePriceProd = Math.abs(getProduct.constPrice) + shi
        if (getBySellProfit) setProduct({...getProduct, price: nwePriceProd})
        setShipPriceSelect({price: shi,  Select: 'Moyenne'})
       
       
    }else if (o ==='Maximum'){
        let shi = k[1]
        let nwePriceProd = Math.abs(getProduct.constPrice) + shi
        if (getBySellProfit) setProduct({...getProduct, price: nwePriceProd})
        setShipPriceSelect({price: shi,  Select: 'Maximum'}) 
       
    }else{
        let shi = (k[0] +  k[1])/2
        let nwePriceProd = Math.abs(getProduct.constPrice) + shi
        if (getBySellProfit) setProduct({...getProduct, price: nwePriceProd})
        setShipPriceSelect({price: shi,  Select: 'Moyenne'})
    }
}

const handPriceProfit = (mode) => setBySellProfit(mode === "selling_price");
const countryFlagIcon = (ob) => {
    if (/canada/i.test(ob)) return '🇨🇦';
    if (/usa|united states/i.test(ob)) return '🇺🇸';
    return '🌍';
};
const minMoyMaxIcon = (ob) => {
    if (ob === 'Minimum') return <FaArrowDown />;
    if (ob === 'Maximum') return <FaArrowUp />;
    return <FaEquals />;
};

const selectProfitTargetPrice = () => (
    <PricingModeSelector value={getBySellProfit ? "selling_price" : "desired_profit"} onChange={handPriceProfit} />
);

const selectMinMoyMax =()=>{
    return getshipping?.length > 0 && <div className="form-group mt-0 sim-shipping-result">
            <h5>{cellSeleted[0]} {headTitle[cellSeleted[2]]}</h5>

           <div className="sim-pill-group m-4">
           { shippinselected?.map((ob, i) =>{
            return <span className="sim-pill" key={i}> <input
                            className="form-check-input"
                            onChange={()=>handleMinMoyMax(ob, getshipping)}
                            checked={getShipPriceSelect['Select'] == ob ? 'checked' : ''}
                             type="radio"
                             name="shipPriceSelect"
                             id={"shipPriceSelect_" + ob}
                              />
                       <label className="form-check-label" htmlFor={"shipPriceSelect_" + ob}>{minMoyMaxIcon(ob)} {ob}</label>
                    </span>
           })}
           </div>
           <table className="col-4 table table-sm m-4" >
            <tbody>
            <tr>
                <th className="w-50"><span className="fw-bolder mr-3">
                    {/* shipping price */}
                    {infoSource.language(infoSource, "sellPage", "shipPrice")}:
                    </span> </th>
                <td>{deliveryTime[1]}</td>
            </tr>
            <tr>
                <th><span className="fw-bolder mr-3">
                    {/* Deliver time */}
                    {infoSource.language(infoSource, "sellPage", "delivTime")}:
                    </span> </th>
                <td>{deliveryTime[0]}</td>
            </tr>
            <tr>
                <th><span className="fw-bolder mr-3">
                    {/* shipping price selected:  */}
                    {infoSource.language(infoSource, "sellPage", "shipPriSel")}:
                    ({getShipPriceSelect.Select})</span> </th>
                <td>
                {shippingboo ?
                    (getShipPriceSelect.price).toLocaleString('en-US', {
                        style: 'currency',
                        currency: 'USD',
                    }) :
                        (0).toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        })
                }
                </td>
            </tr>
            </tbody>
           </table>
         </div> 
}

const selectTypelist =()=>{
    return  <div className="form-group sim-pill-group">
           { contryShip?.map((ob, i) =>{
            return <span className="sim-pill" key={i}> <input
                        className="form-check-input"
                         onChange={()=>handleStylePara(ob, i, 'a')}
                         checked={getLinkShoose['contries'] == ob ? 'checked' : ''}
                         type="radio"
                         name="contries"
                         id={"contries_" + ob}
                         />
                       <label className="form-check-label" htmlFor={"contries_" + ob}>{countryFlagIcon(ob)} {ob}</label>
                    </span>
           })}
       </div>

}

const selectcompagnies =()=>{
    let objKey =  Object.keys(shippingData[1][getLinkShoose.contries])
    return  <div className="form-group sim-pill-group">
           { objKey?.map((ob, i) =>{
            return <span className="sim-pill" key={i}> <input
                        className="form-check-input"
                        onChange={()=>handleStylePara(ob, i, 'b')}
                        checked={getLinkShoose['compagnies'] == ob ? 'checked' : ''}
                        type="radio"
                        name="compagnies"
                        id={"compagnies_" +ob}
                        />
                       <label className="form-check-label" htmlFor={"compagnies_" + ob}><FaShippingFast /> {ob}</label>
                    </span>
           })}
       </div>

}

const PaymentAchat =()=>(
    <table className="table table-sm">
        <tbody>
            <tr>
                <th>{count} {infoSource.laguangeElakay('label', infoSource.languageAPI).items} : </th>
                <td>{(getSimulationPrice.ItemsOrder).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })} </td>
            </tr>
            <tr>
                <th>{infoSource.laguangeElakay('label', infoSource.languageAPI).shipping} : </th>
                <td>{
                    shippingboo ?
                    (0).toLocaleString('en-US', {
                        style: 'currency',
                        currency: 'USD',
                    }) :
                        (0).toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        })
                }
                </td>
            </tr>
            <tr>
                <th>{infoSource.laguangeElakay('label', infoSource.languageAPI).tax} : </th>
                <td>{(getSimulationPrice.TaxOrder).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}
                </td>
            </tr>
            <tr className="table-primary">
                <th className="text-danger" style={{ fontSize: "18px" }}> {infoSource.laguangeElakay('label', infoSource.languageAPI).total}: </th > <td className="text-danger" style={{ fontSize: "18px" }}>{(getSimulationPrice.getTotal).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}</td>
            </tr>
       
        </tbody>
    </table>
    
)

const profitLost = ()=>{
   return <>
   <h3><FaChartLine className="sim-card__icon" />
    {/* Sales Similutation */}
    {infoSource.language(infoSource, "sellPage", "SalSimiL")}
    </h3>

   <div className="sim-stat-grid">
        <div className="sim-stat">
            <span className="sim-stat__label">{infoSource.language(infoSource, "sellPage", "PurPrice")}</span>
            <span className="sim-stat__value">{(Number(getPurchaseProduct.purchasePrice)).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            })}</span>
        </div>
        <div className="sim-stat">
            <span className="sim-stat__label">
                {infoSource.language(infoSource, "sellPage", "SalPrice")}
                {" "}({ shippingboo ?elakayAutoText("h_3eb81f004742f3", "with shipping price"):elakayAutoText("h_2c5bd9b85067c8", "without shipping price")})
            </span>
            <span className="sim-stat__value">{(getSimulationPrice.ItemsOrder).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            })}</span>
        </div>
        <div className="sim-stat">
            <span className="sim-stat__label">{infoSource.language(infoSource, "sellPage", "shipCost")}</span>
            <span className="sim-stat__value">{(getShipPriceSelect.price).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            })}</span>
        </div>
        <div className="sim-stat">
            <span className="sim-stat__label">{infoSource.language(infoSource, "sellPage", "inCome")}</span>
            <span className="sim-stat__value">{(getSimulationPrice.inComeSeller).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            })}</span>
        </div>
   </div>

   <div className="sim-result-grid">
        <div className="sim-result sim-result--profit">
            <span className="sim-result__label">{infoSource.language(infoSource, "sellPage", "profit")}</span>
            <span className="sim-result__value">{(getSimulationPrice.statut.profit).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            })}</span>
        </div>
        <div className="sim-result sim-result--loss">
            <span className="sim-result__label">{infoSource.language(infoSource, "sellPage", "loss")}</span>
            <span className="sim-result__value">{(getSimulationPrice.statut.loss).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            })}</span>
        </div>
        <div className="sim-result sim-result--statut">
            <span className="sim-result__label">{infoSource.language(infoSource, "sellPage", "statut")}</span>
            <span className="sim-statut-badge">{getSimulationPrice.statut.statut}</span>
        </div>
   </div>
   </>
}

const PaymentAchVent =()=>(
    <table className="table table-sm">
        <tbody>
        <tr>
                <th>
                    {/* prix befor discount  */}
                    {infoSource.language(infoSource, "sellPage", "pribefdisc")}: 
                    </th>
                <td>{(getSimulationPrice.prodPrice).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })} </td>
            </tr>
            <tr>
                <th>
                    {/* prix after discount */}
                    {infoSource.language(infoSource, "sellPage", "prAftDisc")}:
                     </th>
                <td>{(getSimulationPrice.ItemsOrder).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })} </td>
            </tr>
            <tr>
                <th>
                    {/* Discount  */}
                    {infoSource.language(infoSource, "sellPage", "discount")}:
                    {getProduct.salePrice}%: </th>
                <td>{(getSimulationPrice.prodDiscount).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}
                </td>
            </tr>
            <tr>
                <th>{infoSource.laguangeElakay('label', infoSource.languageAPI).shipping} : </th>
                <td>{
                    shippingboo ?
                        (0).toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        }) :
                        (0).toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        })
                }
                </td>
            </tr> 
            <tr>
                <th>{infoSource.laguangeElakay('label', infoSource.languageAPI).tax} : </th>
                <td>{(getSimulationPrice.TaxOrder).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}
                </td>
            </tr>
            <tr className="table-primary">
                <th className="text-danger" style={{ fontSize: "18px" }}> {infoSource.laguangeElakay('label', infoSource.languageAPI).total}: </th> <td className="text-danger" style={{ fontSize: "18px" }}>{(getSimulationPrice.getTotal).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}</td>
            </tr>

          <tr>
                <th>
                    {/* Frais paiements 2.9% + $0.30 */}
                    {infoSource.language(infoSource, "sellPage", "fraiPaiem")}: 
                    </th>
                <td>{(getSimulationPrice.prodFrTransaction).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}
                </td>
            </tr>
            <tr>
                <th>{__elakayText("t004", "elakay Feet 6% + $")}{ parseFloat(clotureFeet).toFixed(2)}: </th>
                <td>{(getSimulationPrice.elakayFrais).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}
                </td>
            </tr>
            <tr className="table-secondary">
                <th className="text-danger" style={{ fontSize: "18px" }}> 
                    {/* Total des Frais  */}
                    {infoSource.language(infoSource, "sellPage", "TotFrais")}: 
                    </th> <td className="text-danger" style={{ fontSize: "18px" }}>{(getSimulationPrice.totalFrais).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}</td>
            </tr>

            <tr className="table-success">
                <th className="text-danger">
                    {/* Revenu Net  */}
                    {infoSource.language(infoSource, "sellPage", "revNet")}: 
                    </th>
                <td className="text-danger">{(getSimulationPrice.inComeSeller).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}
                </td>
            </tr>
            
        </tbody>
    </table>
    
)

const PaymentVente =()=>(
    <table className="table table-sm">
        <tbody>
            <tr>
                <th>{1} {infoSource.laguangeElakay('label', infoSource.languageAPI).items} : </th>
                <td>{(getSimulationPrice.prodPrice).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })} </td>
            </tr>
            <tr>
                <th>{infoSource.laguangeElakay('label', infoSource.languageAPI).shipping} : </th>
                <td>{
                    shippingboo ?
                        (0).toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        }) :
                        (0).toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        })
                }
                </td>
            </tr>
            <tr style={{ textDecoration: "line-through", fontStyle: "italic", fontFamily: "myFirstFont", fontSize: "15px" }}>
                <th>{infoSource.laguangeElakay('label', infoSource.languageAPI).tax} : </th>
                <td>{(getSimulationPrice.TaxOrder).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}
                </td>
            </tr>
            <tr style={{ textDecoration: "line-through", fontStyle: "italic", fontFamily: "myFirstFont", fontSize: "15px" }}>
                <th>
                    {/* Discount  */}
                    {infoSource.language(infoSource, "sellPage", "discount")}:
                     </th>
                <td>{(getSimulationPrice.prodDiscount).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}
                </td>
            </tr>
            <tr>
                <th>
                    {/* Frais de Service  */}
                    {infoSource.language(infoSource, "sellPage", "fraisServi")}: 
                    </th>
                <td>{(getSimulationPrice.prodFrService).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}
                </td>
            </tr>
            <tr>
                <th>
                    {/* Frais paiements */}
                    {infoSource.language(infoSource, "sellPage", "fraispaie")}: 
                    </th>
                <td>{(getSimulationPrice.prodFrTransaction).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}
                </td>
            </tr>
            <tr>
                <th> 
                    {/* Frais de Vente */}
                    {infoSource.language(infoSource, "sellPage", "fraiVente")}: 
                    </th>
                <td>{(getSimulationPrice.prodFrVente).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}
                </td>
            </tr>
            <tr>
                <th> 
                    {/* Frais Gestion & d'Expedition  */}
                    {infoSource.language(infoSource, "sellPage", "frGesExpedi")}:
                     </th>
                <td>{(0).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}
                </td>
            </tr>

            <tr>
                <th>
                    {/* Frais de Referencement  */}
                    {infoSource.language(infoSource, "sellPage", "fraiReferen")}:
                     </th>
                <td>{(getSimulationPrice.prodFrRef).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}
                </td>
            </tr>
            <tr>
                <th> 
                    {/* Frais de Clôture  */}
                    {infoSource.language(infoSource, "sellPage", "fraisClotu")}: 
                    </th>
                <td>{(clotureFeet).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}
                </td>
            </tr>

            <tr className="table-secondary">
                <th className="text-danger" style={{ fontSize: "16px" }}> 
                    {/* Total des Frais  */}
                    {infoSource.language(infoSource, "sellPage", "TotFrais")}: 
                    </th> <td className="text-danger" style={{ fontSize: "16px" }}>{(getSimulationPrice.totalFrais).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}</td>
            </tr>

            <tr className="table-success">
                <th className="text-danger">
                    {/* Revenu Net  */}
                    {infoSource.language(infoSource, "sellPage", "revNet")}: 
                    </th>
                <td className="text-danger">{(getSimulationPrice.inComeSeller).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })}
                </td>
            </tr>

       
        </tbody>
    </table>
    
)

const order = () => (
    <div className="sim-order-grid">
        <div className="sim-mini-card">
            <h5><FaReceipt className="sim-card__icon" />
                {/* Details de Vente */}
                {infoSource.language(infoSource, "sellPage", "DetailsVente")}
            </h5>
            {PaymentVente()}

            <h5>
                {/* Details des Achats */}
                {infoSource.language(infoSource, "sellPage", "detaiAchats")}
            </h5>
            {PaymentAchat()}
        </div>

        <div className="sim-mini-card">
            <h5>
                {/* Details Achats & vente */}
                {infoSource.language(infoSource, "sellPage", "detAchVent")}
            </h5>
            {PaymentAchVent()}
        </div>
    </div>
)

return <div className="sales-sim" aria-busy={simulation.loading}>
    {simulation.loading && <p role="status"><span className="spinner-border spinner-border-sm" aria-hidden="true" /> {elakayAutoText("h_ps_loading", "Calculating…")}</p>}
    {simulation.error && <p role="alert" className="text-danger">{elakayAutoText("h_ps_preview_failed", "The simulation could not be loaded. Please try again.")}</p>}
    <div className="sim-card sim-card--intro">
        {infoDiscount()}
    </div>

    <div className="sim-card">
        <h4 className="sim-card__title"><FaTags className="sim-card__icon" />{__elakayText("t006", "Catégorie du produit")}</h4>
        <CatSearch
            infoSource={infoSource}
            search ={search}
            setSearch ={setSearch}
            setSearchInput={setSearchInput}
            searchInput={searchInput}
            getCategoriesByName={getCategoriesByName}
            categories={categories}
            loadCategory={loadCategory}
        />
    </div>

    <div className="sim-card">
        <h4 className="sim-card__title"><FaMoneyBillWave className="sim-card__icon" />{__elakayText("t007", "Prix d'achat et profit visé")}</h4>
        {formPurchase()}
        {selectProfitTargetPrice()}
    </div>

    <div className="sim-card">
        <h4 className="sim-card__title"><FaPercentage className="sim-card__icon" />{__elakayText("t008", "Prix de vente et remise")}</h4>
        {allForm()}
    </div>

    <div className="sim-card">
        <h4 className="sim-card__title"><FaTruck className="sim-card__icon" />{__elakayText("t009", "Frais de livraison")}</h4>
        {TableInfoShip()}
    </div>

    {getSimulationPrice.ItemsOrder > 0 && (
        <div className="sim-card sim-card--results">
            {!getBySellProfit && <div className="sim-stat">
                <span className="sim-stat__label">{elakayAutoText("h_ps_calculated_price", "Calculated Selling Price")}</span>
                <strong className="sim-stat__value">{Number(simulation.result?.report?.sellingPrice || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</strong>
            </div>}
            {profitLost()}
        </div>
    )}

    {getSimulationPrice.ItemsOrder > 0 && (
        <div className="sim-card sim-card--order">
            {order()}
        </div>
    )}
</div>
}
export default SalesSimulation
